module.exports = __webpack_public_path__ + "fonts/CircularStd-Book.829012af.woff";